import type { OrganizationState } from '../../../types';

export const initOrganizationState = (state: OrganizationState | null) => {
  if (state === null) {
    return { organizationId: '', organizationName: '', ssoStatus: null };
  } else {
    return {
      organizationId: state.organizationId,
      organizationName: state.organizationName,
      ssoStatus: state.ssoStatus,
    };
  }
};
